// Will be replaced during production builds - see prepare.sh
export const BuildVersion = "c9d7112";
